import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-26a59a57")

_pushScopeId("data-v-26a59a57")
const _hoisted_1 = { class: "text" }
const _hoisted_2 = { class: "quote-author" }
const _hoisted_3 = { class: "quote-genre" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createVNode("span", { class: "material-icons-outlined arrow_icon" }, "arrow_right_alt")
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: "QuoteDetails",
    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.redirectUserToAuthorPage && _ctx.redirectUserToAuthorPage(...args)))
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("h2", _hoisted_2, _toDisplayString(_ctx.quoteAutor), 1),
      _createVNode("h3", _hoisted_3, _toDisplayString(_ctx.quoteGenre), 1)
    ]),
    _hoisted_4
  ]))
})